import { multiStep } from 'components/Wizards/MultiStepWizard/multiStep'
import { Form } from 'components/Wizards/Form/Form'
import { useFormikContext } from 'formik'
import { Button } from 'blaze-ui/Button/Button'
import Styles from './CustomizeTopic.module.scss'
import { Values } from '../../Types'
import { IMediaFile } from 'components/Design/UploadsTab/Types'
import { StepProps } from 'components/Wizards/MultiStepWizard/Types'
import { Formik } from 'formik'
import { DesktopTopic } from '../../PurposeAndGoals/DesktopTopic'

interface Props extends StepProps {
  selectedMediaFile: IMediaFile
  createDesign: (values: Values) => Promise<void>
  setConfirmedVideo: (value: boolean) => void
}

export const CustomizeTopic = multiStep<Props>((props) => {
  const { schema, onSubmit } = props

  return (
    <Formik
      validationSchema={schema}
      onSubmit={onSubmit}
      initialValues={schema.cast({ ...schema.getDefault(), ...props.initialValues }, { assert: false })}
    >
      {() => <Content {...props} />}
    </Formik>
  )
})

export const Content = multiStep<Props>((props) => {
  const { selectedMediaFile, createDesign, setConfirmedVideo, onBack, schema } = props
  const { submitForm, isSubmitting, initialValues, values } = useFormikContext<Values>()

  const fieldsWithName = (names: string[]) => Object.entries(schema.fields).filter(([name]) => names.includes(name))
  const topicField = fieldsWithName(['topic'])[0]

  const handleGoToDesigner = async () => {
    await createDesign({
      ...initialValues,
      initial_media_file_id: values.initial_media_file_id,
      filename: 'Video Post',
    })
  }

  const handleSubmit = () => {
    setConfirmedVideo(true)
    submitForm()
  }

  return (
    <Form.Root>
      <Form.Section>
        <Form.SectionContent>
          <Form.Fields className={Styles.fields}>
            {topicField && <DesktopTopic topicSchema={topicField[1]} />}
            <div className={Styles.selectedVideo}>
              <video src={selectedMediaFile.source_url} controls muted autoPlay />
            </div>
          </Form.Fields>
        </Form.SectionContent>
      </Form.Section>

      <Form.Actions isSticky>
        <Form.PreviousButton onPress={onBack}>Back</Form.PreviousButton>
        <div className={Styles.footerButtonsRight}>
          <Button variant="tertiary" size="lg" isDisabled={isSubmitting} onPress={handleGoToDesigner}>
            Go Straight to Designer
          </Button>
          <Button variant="primary" size="lg" onPress={handleSubmit} isDisabled={isSubmitting}>
            Pick your Template
          </Button>
        </div>
      </Form.Actions>
    </Form.Root>
  )
})
